import { ExcelAsset } from '@Types/Asset.types';
import { EXCEL_VALUE_MAP, FIELD_NAMES, NON_STRING_FIELDS } from '@Utils/constants';

type ExcelPrunedInfo = {
  [k: string]: string | number | boolean;
};

export const formatExcelData = (rows: [][]) => {
  const data: ExcelPrunedInfo[] = [];

  for (const row of rows) {
    // Remove unneeded fields
    const splicedValues = row.slice(0, 21);
    const isEmpty = !splicedValues.every((value) => value === null);

    if (isEmpty) {
      const excelAsset: Partial<ExcelAsset> = {};
      EXCEL_VALUE_MAP.forEach((field, index) => {
        if (index in splicedValues) {
          excelAsset[field as keyof ExcelAsset] = splicedValues[index];
        }
      });

      // Remove empty values
      const prunedInfo = Object.fromEntries(
        Object.entries(excelAsset).filter(([, value]) => value !== '' && value !== null),
      );

      // Ensure string types
      Object.keys(prunedInfo).forEach((key) => {
        prunedInfo[key] = NON_STRING_FIELDS.includes(key as FIELD_NAMES) ? prunedInfo[key] : prunedInfo[key].toString();
      });

      data.push(prunedInfo);
    }
  }
  data.shift();

  return data;
};
